// Lecturas públicas. apiFetch añade X-Institucion, así que los slugs de categoría (únicos por
// institución) se resuelven dentro de la institución activa.
import { apiFetch } from './apiFetch';

export const getCategorias = (institucionSlug) =>
  apiFetch(`/api/categorias/${encodeURIComponent(institucionSlug)}`);

export const getSubcategorias = (categoriaSlug) =>
  apiFetch(`/api/categorias/${encodeURIComponent(categoriaSlug)}/subcategorias`);

export const getCategoriaDetalle = (categoriaSlug) =>
  apiFetch(`/api/categorias/${encodeURIComponent(categoriaSlug)}/detalle`);

export const getPublicaciones = (categoriaSlug) =>
  apiFetch(`/api/publicaciones/${encodeURIComponent(categoriaSlug)}`);

// Vitrina del portal de la plataforma: últimas publicaciones de las instituciones visibles en él.
export const getPublicacionesRecientes = (limite = 8) =>
  apiFetch(`/api/publicaciones/recientes?limite=${encodeURIComponent(limite)}`);

export const getPublicacion = (categoriaSlug, publicacionSlug) =>
  apiFetch(`/api/publicaciones/${encodeURIComponent(categoriaSlug)}/${encodeURIComponent(publicacionSlug)}`);
